// Utils
import { http } from './services/http';
import { ApplicationType } from '../../common/platform/platformTypes';
import { VersionValidationQuery, VersionValidationResponse } from '../../common/api/version/appVersionRouteTypes';
import globalLogger from '../logger/logger';

const logger = globalLogger.createChannel('version-service');

export const fetchAppVersionStatus = async (
    currentVersion: string,
    appType: ApplicationType,
): Promise<VersionValidationResponse> => {
    const params: VersionValidationQuery = {
        version: currentVersion,
        appType,
    };

    try {
        const response = await http<VersionValidationQuery, VersionValidationResponse>({
            url: `version/status`,
            params,
        });

        return response.data;
    } catch (error) {
        // Sensitive data audit: SAFE — static message + sanitized error object
        logger.error('Failed to fetch app version status', error);

        // if an error occurs, assume the version is safe and up to date
        // — we probably don't want to force users to update if the service is down
        return {
            currentVersion,
            upToDate: true,
            safe: true,
            isBlocked: false,
            error: 'Error fetching version status',
        };
    }
};

export const validateAppVersionIsSafe = async (currentVersion: string, appType: ApplicationType) => {
    const versionStatus = await fetchAppVersionStatus(currentVersion, appType);
    return versionStatus.safe;
};
